const updateProgressBar = (store) => {
  const amountRemaining = store.progressBarThreshold - store.total_price;

  if (amountRemaining <= 0) {
    store.progress_bar_amount_remaining = 0;
    store.progress_bar_percent = '100%';
    return;
  }

  store.progress_bar_amount_remaining = amountRemaining;

  const thresholdCurrencyCalc = store.progressBarThreshold * (+window.Shopify.currency.rate || 1);
  store.progress_bar_percent = `${(store.total_price / thresholdCurrencyCalc) * 100}%`;
};

export const cart = {
  loading: false,
  items: [],
  item_count: 0,
  total_price: 0,
  original_total_price: 0,
  total_discount: 0,
  cart_level_discount_applications: [],
  note: '',
  progress_bar_amount_remaining: 0,
  progress_bar_percent: '0%',
  progressBarThreshold: 0,
  recommendationProductId: null,

  init() {
    const app = window.blueprintData;

    this.items = app.cart.items;
    this.item_count = app.cart.item_count;
    this.recommendationProductId = app.cart.items[0]?.product_id ?? null;
    this.total_price = app.cart.total_price;
    this.original_total_price = app.cart.original_total_price;
    this.total_discount = app.cart.total_discount;
    this.note = app.cart.note;
    this.progressBarThreshold = app.progressBarThreshold;

    updateProgressBar(this);
  },

  async updateCart(openDialog = true) {
    this.loading = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`Error fetching cart: ${response.status}`);
      }

      const data = await response.json();

      this.items = data.items;
      this.recommendationProductId = data.items[0]?.product_id ?? null;
      this.item_count = data.item_count;
      this.total_price = data.total_price;
      this.original_total_price = data.original_total_price;
      this.total_discount = data.total_discount;
      this.cart_level_discount_applications = data.cart_level_discount_applications;

      updateProgressBar(this);

      setTimeout(() => {
        this.loading = false;
      }, 200);

      if (openDialog) {
        Alpine.store('dialog').open('cart-drawer');
      }
    } catch (error) {
      console.error('Error:', error);
      this.loading = false;
    }
  },

  async submitCartForm(form) {
    this.loading = true;

    const formData = new FormData(form);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Cart error:', data.description);
        this.loading = false;
        return;
      }

      await this.updateCart();
    } catch (error) {
      console.error('Error:', error);
      this.loading = false;
    }
  },

  async changeCartItemQuantity(key, quantity) {
    this.loading = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        body: JSON.stringify({ id: key.toString(), quantity: quantity.toString() }),
        headers: { 'Content-Type': 'application/json' },
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Cart error:', data.description);
        this.loading = false;
        return;
      }

      await this.updateCart(false);
    } catch (error) {
      console.error('Error:', error);
      this.loading = false;
    }
  },

  async updateCartNote(note) {
    this.loading = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description);
      }

      this.items = data.items.map((item) => ({ ...item }));
      await this.updateCart(false);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      this.loading = false;
    }
  },

  generateSharableUrl() {
    const items = this.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
    return `${window.location.origin}/cart/${items}`;
  },
};
